(function () {
  'use strict';

  if (window.__mcHandlePinLoaded) return;
  window.__mcHandlePinLoaded = true;

  var MAX_PINS = 6;
  var TIMEOUT = 10000;
  var activeJob = null;
  var frameId = null;
  var completed = new WeakMap();

  function normalize(value) {
    return String(value || '').trim().toLowerCase();
  }

  function getHandles() {
    var result = [];

    new URLSearchParams(location.search)
      .getAll('pin_handle')
      .forEach(function (value) {
        value.split(',').forEach(function (handle) {
          handle = normalize(handle);

          // 只接受 handle，不接受完整 URL。
          if (
            handle &&
            !/[\/\\?#\s]/.test(handle) &&
            result.indexOf(handle) === -1
          ) {
            result.push(handle);
          }
        });
      });

    return result.slice(0, MAX_PINS);
  }

  function getGrid() {
    return document.querySelector(
      '#ProductGridContainer ul#product-grid'
    );
  }

  function getEntries(grid) {
    return Array.from(grid.children)
      .filter(function (item) {
        return item.matches('li.grid__item');
      })
      .map(function (item) {
        var marker = item.querySelector(
          '[data-pin-product-marker]'
        );

        return {
          item: item,
          handle: marker
            ? normalize(marker.getAttribute('data-product-handle'))
            : ''
        };
      })
      .filter(function (entry) {
        return entry.handle;
      });
  }

  function getKey() {
    return location.pathname + location.search;
  }

  function allowed(grid) {
    if (grid.getAttribute('data-pin-current-page') !== '1') {
      return false;
    }

    var params = new URLSearchParams(location.search);
    var blocked = false;

    params.forEach(function (_, name) {
      if (
        name.indexOf('filter.') === 0 ||
        name === 'sort_by' ||
        name === 'constraint'
      ) {
        blocked = true;
      }
    });

    // 标签类目路径不执行跨页插入。
    return (
      !blocked &&
      /\/collections\/[^/]+\/?$/.test(location.pathname)
    );
  }

  function cancel() {
    if (!activeJob) return;
    activeJob.controller.abort();
    activeJob = null;
  }

  function isCurrent(job) {
    return (
      activeJob === job &&
      !job.controller.signal.aborted &&
      job.grid === getGrid() &&
      job.key === getKey()
    );
  }

  function collect(job) {
    getEntries(job.grid).forEach(function (entry) {
      if (
        job.handles.indexOf(entry.handle) !== -1 &&
        !job.found.has(entry.handle)
      ) {
        job.found.set(entry.handle, entry.item);
      }
    });
  }

  function apply(job) {
  var grid = job.grid;

  var ordered = job.handles.map(function (handle) {
    return job.found.get(handle);
  }).filter(Boolean);

  if (!ordered.length) return;

  // 删除后续分页加载进来的同 handle 重复卡片。
  var pinnedItems = new Map();

  ordered.forEach(function (item) {
    var marker = item.querySelector(
      '[data-pin-product-marker]'
    );

    if (marker) {
      pinnedItems.set(
        normalize(marker.getAttribute('data-product-handle')),
        item
      );
    }
  });

  getEntries(grid).forEach(function (entry) {
    var keep = pinnedItems.get(entry.handle);

    if (keep && entry.item !== keep) {
      entry.item.remove();
    }
  });

  // 已经排在开头时直接退出，不再移动任何节点。
  var current = Array.from(grid.children);

  var alreadyCorrect = ordered.every(function (item, index) {
    return (
      item.parentElement === grid &&
      current[index] === item
    );
  });

  if (alreadyCorrect) return;

  // 从前往后定位插入。
  // 每次只移动位置不正确的卡片，避免反复 B→A 调换。
  var cursor = grid.firstElementChild;

  ordered.forEach(function (item) {
    if (item === cursor) {
      cursor = cursor.nextElementSibling;
    } else {
      grid.insertBefore(item, cursor);
    }
  });
}

  async function fetchCard(job, handle) {
    var root = window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';

    var url = new URL(
      root + 'products/' + encodeURIComponent(handle),
      location.origin
    );

    url.searchParams.set('view', 'mc-pin-card');

    var currentParams = new URLSearchParams(location.search);

    ['preview_theme_id', '_fd', 'pb'].forEach(function (name) {
      if (currentParams.has(name)) {
        url.searchParams.set(name, currentParams.get(name));
      }
    });

    var response = await fetch(url.href, {
      credentials: 'same-origin',
      signal: job.controller.signal
    });

    if (!response.ok) {
      throw new Error(handle + ': HTTP ' + response.status);
    }

    var html = await response.text();
    var page = new DOMParser().parseFromString(html, 'text/html');
    var item = page.querySelector(
      '[data-mc-pin-response] > li.grid__item'
    );

    var marker = item && item.querySelector(
      '[data-pin-product-marker]'
    );

    if (
      !marker ||
      normalize(marker.getAttribute('data-product-handle')) !== handle
    ) {
      throw new Error(handle + ': 没有返回匹配的产品卡');
    }

    return document.importNode(item, true);
  }

  async function load(job) {
    collect(job);
    apply(job);

    var missing = job.handles.filter(function (handle) {
      return !job.found.has(handle);
    });

    var timer = setTimeout(function () {
      job.controller.abort();
    }, TIMEOUT);

    try {
      // 最多 6 个定向请求，不扫描任何产品分页。
      await Promise.all(missing.map(async function (handle) {
        try {
          var item = await fetchCard(job, handle);

          if (isCurrent(job)) {
            job.found.set(handle, item);
          }
        } catch (error) {
          if (isCurrent(job)) {
            console.warn('[Handle pin]', error);
          }
        }
      }));
    } finally {
      clearTimeout(timer);

      if (
        activeJob === job &&
        job.grid === getGrid() &&
        job.key === getKey()
      ) {
        apply(job);
        completed.set(job.grid, job);
        activeJob = null;
      }
    }
  }

  function run() {
    var grid = getGrid();
    var handles = getHandles();

    if (!grid || !handles.length || !allowed(grid)) {
      cancel();
      return;
    }

    var key = getKey();

    if (
      activeJob &&
      activeJob.grid === grid &&
      activeJob.key === key
    ) {
      return;
    }

    cancel();

    var previous = completed.get(grid);

    if (previous && previous.key === key) {
      apply(previous);
      return;
    }

    var job = {
      grid: grid,
      key: key,
      handles: handles,
      found: new Map(),
      controller: new AbortController()
    };

    activeJob = job;
    load(job);
  }

  function schedule() {
    if (frameId !== null) cancelAnimationFrame(frameId);

    frameId = requestAnimationFrame(function () {
      frameId = null;
      run();
    });
  }

  function start() {
    schedule();

    new MutationObserver(function (mutations) {
      var changed = mutations.some(function (mutation) {
        return Array.from(mutation.addedNodes)
          .concat(Array.from(mutation.removedNodes))
          .some(function (node) {
            return node.nodeType === 1 && (
              node.matches(
                '#ProductGridContainer, #product-grid, li.grid__item'
              ) ||
              node.querySelector(
                '#ProductGridContainer, #product-grid'
              )
            );
          });
      });

      if (changed) schedule();
    }).observe(document.body, {
      childList: true,
      subtree: true
    });

    document.addEventListener('shopify:section:load', schedule);
    window.addEventListener('popstate', schedule);
    window.addEventListener('pageshow', schedule);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
